import React from 'react';
import { Col, Icon } from 'antd';

interface CenteredIconProps {
  icon: string;
  iconSize: '16px' | '32px' | '64px';
  style?: {};
}

export const CenteredIcon = ({icon, style, iconSize}: CenteredIconProps) => {
  return (
    <>
      <Col
        span={24} style={{
        ...style,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      >
        <Icon
          type={icon} style={{
          display: 'inline-block',
          verticalAlign: 'middle',
          fontSize: `${iconSize}`
        }}
        />
      </Col>
    </>
  )
};
